export default __webpack_public_path__ + "static/media/sideMenuWhiteCheck.d1b4acdc.svg";